import { render, staticRenderFns } from "./BaseTrainingProgramForm.vue?vue&type=template&id=09bd86e2&scoped=true&"
import script from "./BaseTrainingProgramForm.vue?vue&type=script&lang=js&"
export * from "./BaseTrainingProgramForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseTrainingProgramForm.vue?vue&type=style&index=0&id=09bd86e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd86e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VContainer,VFileInput,VForm,VRow})
